"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var pricing_1 = require("../../../api/pricing");
var PricingEditServices = function (props) {
    var id = props.id, buttonLabel = props.buttonLabel, className = props.className;
    var _a = react_1.useState(false), modal = _a[0], setModal = _a[1];
    var _b = react_1.useState({ name: "", costPrice: "", sellingPrice: "", description: "", frequency: "", serviceId: 0 }), data = _b[0], setData = _b[1];
    var setFormChange = function (field, val) {
        var newData = data;
        newData[field] = val;
        setData(__assign({}, newData));
    };
    var submitForm = function (e) {
        pricing_1.updateService(data).then(function (res) {
            props.modalCallback(res);
            toggle();
        });
    };
    var onLoad = function () {
        console.log(data);
        setData(getServiceData(props.id));
    };
    var getServiceData = function (id) {
        return props.list.reduce(function (acc, item) {
            if (id == item.serviceId)
                acc = {
                    serviceId: item.serviceId,
                    name: item.name,
                    costPrice: item.costPrice,
                    sellingPrice: item.sellingPrice,
                    description: item.description,
                };
            return acc;
        }, {});
    };
    React.useEffect(function () {
        if (data.serviceId == 0) {
            onLoad();
        }
    }, [data, setData]);
    var toggle = function () { return setModal(!modal); };
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" },
                React.createElement("img", { src: "./edit.svg", className: "font-icon" }))),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Edit Services"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "name", id: "name", placeholder: "Name", value: data.name, onChange: function (e) { return setFormChange('name', e.target.value); } })),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "SellingPrice" }, "Selling Price*"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "SellingPrice", id: "SellingPrice", placeholder: "Enter selling price", value: data.sellingPrice, onChange: function (e) { return setFormChange('sellingPrice', e.target.value); } }))),
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "CostPrice" }, "Cost Price*"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "CostPrice", id: "CostPrice", placeholder: "Enter cost price", value: data.costPrice, onChange: function (e) { return setFormChange('costPrice', e.target.value); } })))),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { md: 12 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Description" }, "Description*"),
                                React.createElement(reactstrap_1.Input, { type: "textarea", name: "Description", id: "Description", placeholder: "Enter Description", value: data.description, onChange: function (e) { return setFormChange('description', e.target.value); } })))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: submitForm }, "Confirm")))));
};
exports.default = PricingEditServices;
//# sourceMappingURL=PricingEditServices.js.map